const getPaginationSpread = (pageArray: number[], currentPage: number, totalPages: number) => {
  const start = pageArray.splice(0, 2),
    end = pageArray.splice(-2, 2),
    currentInStart = start.includes(currentPage),
    currentInEnd = end.includes(currentPage),
    inStartOrEnd = currentInStart || currentInEnd,
    currentCloseToStart = currentPage === 3,
    currentCloseToEnd = currentPage === totalPages - 2,
    closeToStartOrEnd = currentCloseToStart || currentCloseToEnd,
    getMiddleNumber = currentCloseToStart ? currentPage + 1 : currentPage - 1,
    getMiddle = closeToStartOrEnd ? getMiddleNumber : '...',
    first = inStartOrEnd || currentCloseToStart ? 3 : '...',
    second = !inStartOrEnd && !closeToStartOrEnd ? currentPage : getMiddle,
    third = inStartOrEnd || currentCloseToEnd ? totalPages - 2 : '...';

  return [...start, ...[first, second, third], ...end];
};

export default getPaginationSpread;
